import { render, staticRenderFns } from "./CampaignsHistoryDatatable.vue?vue&type=template&id=39748518&"
import script from "./CampaignsHistoryDatatable.vue?vue&type=script&lang=js&"
export * from "./CampaignsHistoryDatatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports